module.exports = __webpack_public_path__ + "static/media/4Options.d821891e.png";